import { SINGLE_FAQ } from "./singleFaq.constants";
import { action } from "src/utils/requestActions";

export function requestSingleFaq(payload) {
  return action(SINGLE_FAQ.REQUEST, payload);
}
